import {Component, computed, input} from '@angular/core';
import {AsyncPipe} from '@angular/common';
import {Avatar} from 'primeng/avatar';
import {AvatarGroup} from 'primeng/avatargroup';
import {UserSelect} from '../../../api';
import {Tooltip} from 'primeng/tooltip';
import {ElciaTooltip} from '../tooltip/elcia-tooltip.component';
import {BearerImagePipe} from '../../pipes/bearer-image.pipe';

@Component({
  selector: 'elcia-avatar',
  imports: [
    Avatar,
    AvatarGroup,
    Tooltip,
    ElciaTooltip,
    BearerImagePipe,
    AsyncPipe,

  ],
  templateUrl: './party-avatar.component.html',
  styleUrl: './party-avatar.component.scss',
})
export class PartyAvatar {
  avatars = input.required<UserSelect[]>();
  maxItem = input.required<number>();
  size = input<AvatarSize>();

  displayedAvatars = computed(() => this.avatars().slice(0, this.maxItem()));
  remainingCount = computed(() => Math.max(0, this.avatars().length - this.maxItem()));
  allFullNames = computed(() => this.avatars().map(a => a.fullName).join(", "))
}

export type AvatarSize = 'normal' | 'large' | 'xlarge'

